import { create } from 'apisauce';

// define the api
const api = create({
	baseURL: process.env.REACT_APP_BASE_API_URL,
	withCredentials: true
});

const apiUnsplash = create({
	baseURL: 'https://api.unsplash.com',
	headers: {
		Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_API_KEY}`
	}
});

api.addRequestTransform(request => {
	request.headers.Authorization = `JWT ${window.userToken}`;
});

// { headers: { Authorization: `JWT ${window.userToken}` } }

// apiCore.axiosInstance.interceptors.request.use(
//   config => {
//     let token = localStorage.getItem('token');
//     if (token) {
//       config.headers['Authorization'] = `Token ${token}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );

api.addResponseTransform(response => {
	if (!response.ok) {
		let error;
		if (response.problem === 'SERVER_ERROR') {
			error = 'Server error.';
		} else if (response.problem === 'TIMEOUT_ERROR') {
			error = "Server didn't respond in time.";
		} else if (response.problem === 'CONNECTION_ERROR') {
			error = 'Server not available, bad dns.';
		} else if (response.problem === 'NETWORK_ERROR') {
			error = 'Network not available.';
		} else if (response.problem === 'CANCEL_ERROR') {
			error = 'Request has been cancelled.';
		} else {
			error = response.data?.error;
		}

		response.data = {
			data: {
				error
			}
		};
	}
	// const badluck = Math.floor(Math.random() * 10) === 0
	// if (badluck) {
	//   // just mutate the data to what you want.
	//   response.data.doorsOpen = false
	//   response.data.message = 'I cannot let you do that.'
	// }
});

/*  See docs at https://github.com/infinitered/apisauce

api.get('/repos/skellock/apisauce/commits')
api.head('/me')
api.delete('/users/69')
api.post('/todos', { note: 'jump around' }, { headers: { 'x-ray': 'machine' } })
api.patch('/servers/1', { live: false })
api.put('/servers/1', { live: true })
api.link('/images/my_dog.jpg', {}, { headers: { Link: '<http://example.com/profiles/joe>; rel="tag"' } })
api.unlink('/images/my_dog.jpg', {}, { headers: { Link: '<http://example.com/profiles/joe>; rel="tag"' } })

const api = create({ baseURL: '...' })
const response = await api.get('/slowest/site/on/the/net')
console.log(response.ok) // yay!

Problem Codes
The problem property on responses is filled with the best guess on where the problem lies.
You can use a switch to check the problem.
The values are exposed as CONSTANTS hanging on your built API.

Constant        VALUE               Status Code   Explanation
----------------------------------------------------------------------------------------
NONE             null               200-299       No problems.
CLIENT_ERROR     'CLIENT_ERROR'     400-499       Any non-specific 400 series error.
SERVER_ERROR     'SERVER_ERROR'     500-599       Any 500 series error.
TIMEOUT_ERROR    'TIMEOUT_ERROR'    ---           Server didn't respond in time.
CONNECTION_ERROR 'CONNECTION_ERROR' ---           Server not available, bad dns.
NETWORK_ERROR    'NETWORK_ERROR'    ---           Network not available.
CANCEL_ERROR     'CANCEL_ERROR'     ---           Request has been cancelled.
Only possible if `cancelToken` is provided in config, see axios `Cancellation`.

*/
export { api, apiUnsplash };
